import React from 'react';
import PropTypes from 'prop-types';

import {
  PERMISSION_TYPES,
  CONTRIBUTOR_PERMISSION_CHECK_TYPE,
  CONTRIBUTOR_UPLOAD_ACCESS,
} from '../../../../../constants/contributors';
import ContributorFeatureBlock from './ContributorFeatureBlock';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  entityId: PropTypes.string,
  checkType: PropTypes.oneOf(Object.values(CONTRIBUTOR_PERMISSION_CHECK_TYPE)),
  permissions: PropTypes.arrayOf(PropTypes.string),
  fallbackContent: PropTypes.any,
  checkOwnership: PropTypes.bool,
  isOwner: PropTypes.bool,
};

const UploadPermissionBlock = ({
  entityId,
  permissions = [
    CONTRIBUTOR_UPLOAD_ACCESS.REVIEW,
    CONTRIBUTOR_UPLOAD_ACCESS.PUBLISH,
  ],
  checkType = CONTRIBUTOR_PERMISSION_CHECK_TYPE.ANY,
  children,
  checkOwnership,
  isOwner,
  ...props
}) => {
  const uploadPermissionProps = {
    entityId,
    checkType,
    permissions: permissions.map(permission => ({
      type: PERMISSION_TYPES.UPLOAD_ACCESS,
      permission,
    })),
    checkOwnership,
    isOwner,
  };

  return (
    <ContributorFeatureBlock
      {...props}
      contributorPermissionProps={uploadPermissionProps}
    >
      {children}
    </ContributorFeatureBlock>
  );
};

UploadPermissionBlock.propTypes = propTypes;

export default UploadPermissionBlock;
